import React from 'react';
import { StyledSkeleton } from './InfluencerStoriesSkeleton.styles';

const InfluencerStoriesSkeleton = () => {
  return Array.from({ length: 12 }).map((_, index) => {
    return <StyledSkeleton key={index} $animationTime={6} />;
  });
};

export default InfluencerStoriesSkeleton;
